import React from 'react';
import {StyleSheet, PixelRatio} from 'react-native';
import {GestureDetector, Gesture} from 'react-native-gesture-handler';
import Animated from 'react-native-reanimated';
import type {MoblicoPromotionType} from 'src/types/Promotions';
import Styles from '../../Styles';
import {handleClick} from './MoblicoPromotionClickHandler';
import {ensureHttps} from 'src/services/StringUtils';

type MoblicoPromotionProps = {
  promotion: MoblicoPromotionType;
  promotionViewed: (promotion: MoblicoPromotionType) => void;
  isConnected: boolean;
  index: number;
};

function MoblicoPromotion({
  promotion,
  promotionViewed,
  isConnected,
  index,
}: MoblicoPromotionProps) {
  const uri = ensureHttps(promotion.image.url);

  const tapGesture = Gesture.Tap()
    .enabled(isConnected)
    .maxDistance(5)
    .onEnd((_, success) => {
      if (success) {
        handleClick(promotion);
        promotionViewed(promotion);
      }
    });

  return (
    <GestureDetector gesture={tapGesture}>
      <Animated.View
        style={styles.container}
        accessibilityLabel={`Promotion${index}`}
        nativeID={promotion.caption}
      >
        <Animated.Image source={{uri}} style={styles.image} />
      </Animated.View>
    </GestureDetector>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: PixelRatio.roundToNearestPixel(Styles.Spacing.m2),
    shadowColor: Styles.darkColor,
    flex: 1,
    height: '100%',
    width: '100%',
    shadowOffset: {width: 0, height: 0},
    shadowOpacity: 0.4,
    shadowRadius: Styles.Spacing.m2,
  },
  image: {
    height: '100%',
    width: '100%',
    borderRadius: PixelRatio.roundToNearestPixel(Styles.Spacing.m2),
  },
});

export default MoblicoPromotion;
